export default __webpack_public_path__ + "static/1.1_FR-84091f94feb4d866e319540d188d3626.webp";